import { AnsweringClient } from "../../../../clients/answeringClient";
import { describeApiError, isExpiredSession } from "../../../../utils/apiError";

export interface IAssignment {
  applicationId: number;
  title: string;
  dueDate: Date;
  instrumentTitle: string;
}

export interface DeleteAssignmentModalControllerDelegate {
  didDeleteAssignment: () => void;
  didFailDeleteAssignment: (message: string) => void;
  applicationShouldLogout: () => void;
}

export class DeleteAssignmentModalController {
  constructor(
    private delegate: DeleteAssignmentModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async deleteAssignment(
    accessToken: string,
    userUid: string,
    assignmentId: number,
    hasRetried = false
  ): Promise<void> {
    try {
      await this.answeringClient.deleteAssignment(
        accessToken,
        userUid,
        assignmentId
      );
      this.delegate.didDeleteAssignment();
    } catch (error: any) {
      if (isExpiredSession(error) && !hasRetried) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        return this.deleteAssignment(
          newTokens.accessToken,
          userUid,
          assignmentId,
          true
        );
      }
      this.delegate.didFailDeleteAssignment(
        describeApiError(
          error,
          "Não foi possível remover a aplicação. Tente novamente em instantes."
        )
      );
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
